// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.313 14.063H8.438l-4.5 3.374v-3.375h-2.25a1.125 1.125 0 0 1-1.125-1.124V1.688A1.125 1.125 0 0 1 1.688.563h14.624a1.125 1.125 0 0 1 1.125 1.125v11.25a1.125 1.125 0 0 1-1.125 1.124z'
  />
);

export const viewBox = '0 0 18 18';
